import { Box, componentStyles } from "@mallardbay/lib-react-components"
import React from "react"

import CheckoutButtons from "~components/pages/listing/checkout/checkout-buttons"
import type { QuoteFieldsFragment } from "~graphql/generated/graphql"

interface Props {
    readonly quote: QuoteFieldsFragment
}

export default function CheckoutButtonsMobile({ quote }: Props) {
    const styles = useStyles()

    return (
        <Box style={styles.root}>
            <CheckoutButtons quote={quote} noPadding />
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            display: { base: "block", md: "none" },
            marginTop: "24px",
        },
    })
}
